import lazyGettext from 'js-utils/lazy-gettext';
import gettext from 'js-utils/gettext';

export const MANAGE_TEXTS = {
    allDates: lazyGettext('Manage all dates'),
    canceled: lazyGettext('Canceled'),
    upcomingDate: lazyGettext('Manage next upcoming date'),
};

// Currently only 'DRAFT' and 'LIVE' are in use for this page
export const STATUS_DISPLAY_MAP_UPPERCASE = {
    unsaved: gettext('UNSAVED'),
    draft: gettext('DRAFT'),
    canceled: gettext('CANCELED'),
    live: gettext('LIVE'),
    started: gettext('STARTED'),
    ended: gettext('ENDED'),
    completed: gettext('COMPLETED'),
    deleted: gettext('DELETED'),
};

export const EVENT_HEADER_SERIES_DROPDOWN_ID = 'event-header-series-dropdown';
// Janus Checkpoints for manage navigation
export const MANAGE_OLD_DASHBOARD = 'manage_old_dashboard';
export const MANAGE_PRIVACY_CLICK = 'manage_privacy_click';
export const MANAGE_DISPLAY_CLICK = 'manage_display_click';
export const MANAGE_REFUND_POLICY_CLICK = 'manage_refund_policy_click';
export const MANAGE_COUNTRY_AND_CURRENCY_CLICK =
    'manage_country_and_currency_click';
export const MANAGE_TAX_CLICK = 'manage_tax_click';

// Google analytics for manage navigation
export const ACTION_NAV_LINK_CLICK = 'LeftNavLinkClick';
export const ACTION_NAV_MENU_TOGGLE = 'LeftNavMenuToggle';
export const ACTION_NAV_PAYMENT_OPTIONS = 'Nav2PaymentOptions';
export const ACTION_NAV_CHECKOUT_SETTINGS = 'Nav2CountryCurrency';
export const ACTION_NAV_TAX_OPTIONS = 'Nav2Tax';
export const ACTION_NAV_SHIPPING_SETTINGS = 'Nav2ShippingSettings';
export const ACTION_NAV_DESIGN = 'Nav1Design';
export const ACTION_NAV_PUBLISH_VIEW = 'Nav1PublishView';
export const ACTION_NAV_BASIC_INFO = 'Nav1Basics';
export const ACTION_NAV_DISPLAY = 'Nav2Display';
export const ACTION_NAV_PRIVACY = 'Nav2Privacy';
export const ACTION_HELP_ARTICLE = 'HelpArticle';
export const ACTION_GLOBAL_HEADER_NAV_LINK_CLICK = 'GlobalHeaderNavClick';
export const CATEGORY_MANAGE = 'manage';
export const LABEL_HELP_CENTER = 'HelpCenter';
